/**
 * FutSoccer — Motion utilities
 *
 * Two signature animations:
 *   1. Polaroid develop  — .polaroid elements desaturate/blur until in viewport.
 *   2. Headline reveal   — .reveal-on-scroll headlines split into per-word spans
 *                          and slide up with a 40ms stagger.
 *
 * Both respect prefers-reduced-motion (final state, no transition).
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var supportsIO = 'IntersectionObserver' in window;

  function initPolaroids() {
    var polaroids = document.querySelectorAll('.polaroid');
    if (!polaroids.length) return;
    if (reduceMotion || !supportsIO) {
      polaroids.forEach(function (el) { el.classList.add('is-developed'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries, o) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-developed');
          o.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
    polaroids.forEach(function (el) { obs.observe(el); });
  }

  function prepareReveal(el) {
    if (el.dataset.revealReady) return;
    // Preserve inline whitespace structure by tokenising only the leaf text.
    // Inline child elements (em, strong, br) are kept; their text contents are
    // tokenised but not wrapped — keeps semantic markup intact.
    var raw = el.textContent.trim();
    if (!raw) return;
    var words = raw.split(/\s+/);
    var frag = words.map(function (word, i) {
      var span = document.createElement('span');
      span.style.setProperty('--reveal-index', String(i));
      span.textContent = word;
      return span.outerHTML;
    }).join(' ');
    el.innerHTML = frag;
    el.dataset.revealReady = '1';
  }

  function initHeadlineReveals() {
    var targets = document.querySelectorAll('.reveal-on-scroll');
    if (!targets.length) return;
    targets.forEach(prepareReveal);
    if (reduceMotion || !supportsIO) {
      targets.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries, o) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          o.unobserve(entry.target);
        }
      });
    }, { threshold: 0.35, rootMargin: '0px 0px -5% 0px' });
    targets.forEach(function (el) { obs.observe(el); });
  }

  function init() {
    initPolaroids();
    initHeadlineReveals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
